import classNames from 'classnames';
import './GridTile.scss';

export interface GridTileCssProps {
  gap?: React.CSSProperties['gap'] | number;
}

export interface GridTileProps extends GridTileCssProps {
  children?: React.ReactNode;
  variant?: 'portrait' | 'landscape';
  className?: string;
}
/**
 *
 * @param gap - {@link https://developer.mozilla.org/en-US/docs/Web/CSS/gap | gap } css property.
 * @param variant - Variant for the component choose between portrait or landscape grid.
 * @param children - Any React.Node element.
 * @param className - Additional classNames for the component.
 */
export const GridTile: React.FC<GridTileProps> = ({
  gap,
  variant = 'portrait',
  children,
  className,
  ...rest
}) => {
  return (
    <div className={classNames('vds-grid-tile', className)} {...rest}>
      <div
        className={classNames('vds-grid-tile__container', [`vds-grid-tile__container--${variant}`])}
        style={{ gap }}>
        {children}
      </div>
    </div>
  );
};
